var React = require('react');

function IcNavReception (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M2 10.3284V19h2v-2c0-2.7614 2.23858-5 5-5 2.7614 0 5 2.2386 5 5v2h2v-8.6716L9 3.32843 2 10.3284zM9 .5l9 9V21h-6v-4c0-1.6569-1.3431-3-3-3-1.65685 0-3 1.3431-3 3v4H0V9.5l9-9z","fill":"currentColor"}));
}

IcNavReception.defaultProps = {"fill":"none","viewBox":"0 0 18 21"};

module.exports = IcNavReception;

IcNavReception.default = IcNavReception;
